'use strict';

import { base, log, Component, PropTypes, update, sub, fromJS, toJS, mq, ReactChildren, Listener, redirect } from 'core';

import { Paper } from 'material-ui';

import { Masonry } from 'masonry';

import HSSection from 'c/layout/hsLayout/section';
import PageWrapper from 'c/layout/pageWrapper';

import Card from 'c/card/product';

@base({
    track: [['cards']]
})
class Section extends Component {

    render() {

        const { get, sub } = this._store();

        const { key = 'home', layout: layout_key } = this._get().toJS();

        const layout = get('layouts', `${layout_key}`);

        const cards = get('cards').toOrderedMap()
                                  .filter(card => card.get('section') == key)
                                  .toArray()
                                  .sort((a, b) => a.get('id') - b.get('id'))
                                  ;
        
        console.log(JSON.stringify(cards, null, 2));
        // 
        console.log(JSON.stringify(layout.get('layout').toJS().map((grid, i) =>
            // (cards[i]) ? (grid) : (grid)
            [grid, cards[i]]
        ), null, 2));

        const gridCards = layout.get('layout').toJS().map((grid, i) => (cards[i]) ?
            <Card key={`p:${i}:${cards[i].get('id')}`} {...grid} {...sub('cards', `${cards[i].get('id')}`)} /> :
            <Card key={`r:${i}`} {...grid} {...sub('cards', `raw`)} />
        );
        const section =
            <Masonry items={ gridCards } />;

        log.low('  section', key, layout_key);

        return (
            <HSSection>
                { section }
            </HSSection>
        );
    }
}

@base({
    track: [['sections']]
})
class Sections extends Component {

    render() {

        const sections = this._get('pages', `${this.props.page}`, 'sections');

        log.bold('  sections', toJS(sections));

        return (
            <div style={{ height: '100%' }}>
                { sections.map((section, i) =>
                    <Section key={`s:${i}`} {...this._sub('sections', `${section}`)} />
                 )}
            </div>
        );
    }
}

@base({
    track: [['router', 'location']]
})
class Products extends Component {

	render() {

        const page = (window.location.pathname)
                            .split('/')
                            .filter(c => c != '')
                            .shift() || 'home';

        log.bold('  productsHandler', page);

  		return (
            <PageWrapper className="page">
                <Sections page={page}/>
            </PageWrapper>
        );
	}
};

export default Products



// WEBPACK FOOTER //
// ./ui/c/products/index.jsx